document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("fullscreen-modal");
  const announcement_bar = document.querySelector(".announcement-bar");
  const headerElement = document.querySelector(".header");
  const header_component = document.querySelector("header-component");
  const headerElementmobile = document.querySelector(".halo-header-mobile");

  //  LAZY LOAD STATE
  let customizerReady = false;
  let customizerLoading = null;

  //  Make DOMContentLoaded callbacks registered by lazily-loaded scripts run
  //  after the current paint. Those scripts (option-card.js) are injected AFTER
  //  the real DOMContentLoaded has fired, so an event listener would never
  //  trigger. Scheduling this as a task keeps heavy init from blocking the
  //  modal loader paint in the same script-load turn.
  function patchReadyListeners() {
    if (patchReadyListeners.done) return;
    patchReadyListeners.done = true;
    const nativeAdd = document.addEventListener.bind(document);
    document.addEventListener = function (type, listener, options) {
      if (type === "DOMContentLoaded" && document.readyState !== "loading") {
        setTimeout(() => listener.call(document, new Event("DOMContentLoaded")), 0);
        return;
      }
      return nativeAdd(type, listener, options);
    };
  }

  function waitForInjectedStyles(container) {
    const links = Array.from(container.querySelectorAll('link[rel="stylesheet"]'));
    const pending = links
      .filter((link) => !link.sheet)
      .map((link) => new Promise((resolve) => {
        link.addEventListener("load", resolve, { once: true });
        link.addEventListener("error", resolve, { once: true });
      }));

    if (!pending.length) return Promise.resolve();
    return Promise.race([
      Promise.all(pending),
      new Promise((resolve) => setTimeout(resolve, 1200)),
    ]);
  }

  function waitForPaint() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }

  //  Inject the customizer markup from its <template> and load its scripts once.
  function loadCustomizer() {
    if (customizerReady) return Promise.resolve();
    if (customizerLoading) return customizerLoading;

    customizerLoading = new Promise((resolve) => {
      //  TIMING — measure how long the customizer template content takes to load.
      const t0 = performance.now();
      const mark = (label) =>
        console.log(
          `[customizer] ${label}: ${(performance.now() - t0).toFixed(1)}ms`
        );

      const template = document.getElementById("customizer-template");
      if (!template) {
        customizerReady = true;
        resolve();
        return;
      }

      //  Read script sources before the template is removed.
      const scripts = [
        template.getAttribute("data-option-card-src"),
      ].filter(Boolean);

      const parent = template.parentElement;

      //  STEP-BY-STEP LOAD.
      //  Phase 1 (now): the light, immediately-visible content — fabric box,
      //  the main style list (.overview-list[data-index="0"]) and the action
      //  buttons. Pull the heavy child option lists (.customizer-list.childs-list
      //  — thousands of collection <li>s, the part that froze the UI) OUT of the
      //  template before injecting so they don't get cloned/laid out up front.
      //  Each one is injected on demand, per step, when its style is clicked
      //  (see injectChildList / option-card.js getnewList).
      const deferredChildLists = Array.from(
        template.content.querySelectorAll(".customizer-list.childs-list")
      );
      deferredChildLists.forEach((list) => list.remove());

      //  Move (don't clone) the now-light content into the modal — moving avoids
      //  duplicating the whole subtree.
      parent.appendChild(template.content);
      template.remove();
      mark(
        `phase 1 injected (${deferredChildLists.length} child lists deferred)`
      );

      //  The child-list <ul>s are kept referenced for the page's lifetime (in
      //  deferredChildLists) so they can be attached on demand AND detached again
      //  after Apply, then re-attached if the user edits that step. Attached state
      //  is tracked via node.isConnected rather than by mutating the array.
      const overviewOf = () => parent.querySelector(".overview");

      //  Inject ONE child list <ul> on demand, matched by its childsIn class
      //  ("styles"/"contrasts") + data-index, into its original spot inside
      //  .overview. option-card.js calls this from getnewList the moment a style
      //  li[data-list] is clicked, so each step's heavy cards are materialized
      //  only when that step is actually opened.
      function injectChildList(childsIn, index) {
        const overview = overviewOf();
        if (!overview) return;
        const idx = String(index);
        deferredChildLists.forEach((ul) => {
          if (
            !ul.isConnected &&
            ul.classList.contains(childsIn) &&
            ul.getAttribute("data-index") === idx
          ) {
            overview.appendChild(ul);
          }
        });
      }

      //  Inject every detached child list at once — for flows that touch all
      //  lists without going step-by-step (load-previous, summary "Edit").
      function injectAllChildLists() {
        const overview = overviewOf();
        if (!overview) return;
        const frag = document.createDocumentFragment();
        deferredChildLists.forEach((ul) => {
          if (!ul.isConnected) frag.appendChild(ul);
        });
        if (frag.childNodes.length) overview.appendChild(frag);
      }

      //  Detach every currently-attached child list (called after Apply once the
      //  choice is captured on the parent card). Nodes stay referenced, so the
      //  inject functions can re-attach them when the user edits that step.
      function removeAllChildLists() {
        deferredChildLists.forEach((ul) => {
          if (ul.isConnected) ul.remove();
        });
      }

      window.__injectCustomizerChildList = injectChildList;
      window.__injectCustomizerChildLists = injectAllChildLists;
      window.__removeCustomizerChildLists = removeAllChildLists;

      patchReadyListeners();
      const stylesReady = waitForInjectedStyles(parent);
      stylesReady.then(() => mark("styles ready"));

      function loadNext(i) {
        if (i >= scripts.length) {
          stylesReady.then(waitForPaint).then(() => {
            customizerReady = true;
            mark("TOTAL (phase 1 ready)");
            resolve();
            //  Child lists are no longer injected up front — each one is
            //  materialized on demand when its style is clicked (see
            //  option-card.js getnewList → window.__injectCustomizerChildList).
          });
          return;
        }
        const sStart = performance.now();
        const s = document.createElement("script");
        s.src = scripts[i];
        s.onload = () => {
          console.log(
            `[customizer] script ${scripts[i]} loaded+executed: ` +
              `${(performance.now() - sStart).toFixed(1)}ms`
          );
          loadNext(i + 1);
        };
        s.onerror = () => loadNext(i + 1);
        document.body.appendChild(s);
      }

      //  Let the injected DOM, CSS, and loader paint before option-card.js runs
      //  its startup queries/listeners. Without this yield, the first click can
      //  spend a long task cloning DOM and executing the customizer script before
      //  the user sees the modal respond.
      stylesReady.then(waitForPaint).then(() => {
        mark("first paint done — starting scripts");
        loadNext(0);
      });
    });

    return customizerLoading;
  }

  //  GLOBAL MODAL ADJUST FUNCTION
  window.adjustModal = function adjustModal() {
    if (!modal) return;
    const customizer = document.querySelector(".modal-content .customizer");
    const overview_list = document.querySelector(".overview-list");
    let activeHeader = headerElement;
    if (!activeHeader || activeHeader.offsetHeight === 0) {
      activeHeader = headerElementmobile;
    }
    if (!activeHeader) return;
    activeHeader.classList.remove("has_sticky", "is_sidebar");
    headerElement?.classList.add("view_increase");
    if (header_component) {
      header_component.removeAttribute("transparent");
    }
    modal.style.display = "flex";
    document.getElementById("whatflow-button-container").classList.add("hidden");
    if (customizer) customizer.style.display = "flex";
    window.scrollTo(0, 0);
    document.body.classList.add("overflow_hidden");
    announcement_bar?.classList.add("hidden--mobile");
    if (overview_list) {
      setTimeout(() => {
        overview_list.classList.add("openchilds");
      }, 200);
    }
    const headerHeight =
      (activeHeader?.offsetHeight || 0) + (announcement_bar?.offsetHeight || 0);
    modal.style.top = headerHeight + "px";
    modal.style.height = `calc(100% - ${headerHeight}px)`;
    modal.style.zIndex = 4;
  };

  //  LOADER inside the modal (shown while the customizer is injected/loaded)
  function showModalLoader() {
    if (!modal) return;
    modal.classList.add("is-loading-customizer");
    let loader = modal.querySelector(".customizer-loader");
    if (!loader) {
      loader = document.createElement("div");
      loader.className = "customizer-loader";
      loader.setAttribute("aria-live", "polite");
      loader.setAttribute("aria-busy", "true");
      loader.innerHTML =
        '<span class="customizer-loader__spinner"></span>' +
        '<span class="customizer-loader__text">Loading customizer…</span>';
      modal.appendChild(loader);
    }
    loader.classList.remove("hidden");
  }

  function hideModalLoader() {
    const loader = modal && modal.querySelector(".customizer-loader");
    if (loader) loader.remove();
    modal?.classList.remove("is-loading-customizer");
  }

  //  OPEN MODAL (MULTIPLE BUTTONS) — lazy load on first click
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest(".open-modal");
    if (!openBtn) return;

    //  Already loaded — just reopen, no loader needed
    if (customizerReady) {
      setTimeout(() => window.adjustModal(), 50);
      return;
    }

    //  TIMING — measure from this click until the template content is fully
    //  injected, styled, painted, and its script has run.
    const clickT0 = performance.now();
    console.log("[customizer] open-modal clicked — loading content…");

    //  First open — show loaders on the button and in the modal while it loads.
    //  Kick off injection first so a hiccup in adjustModal can never block it.
    openBtn.classList.add("is-loading");
    showModalLoader();
    const loading = loadCustomizer();
    window.adjustModal(); // reveal the (empty) modal shell with the spinner

    loading.then(() => {
      hideModalLoader();
      openBtn.classList.remove("is-loading");
      console.log(
        `[customizer] content ready — ${(performance.now() - clickT0).toFixed(1)}ms ` +
          `from click to fully loaded`
      );
      setTimeout(() => {
        window.adjustModal();
      }, 50);
    });
  });

  //  CLOSE MODAL (delegated — #close-modal is injected lazily)
  document.addEventListener("click", function (e) {
    if (!e.target.closest("#close-modal")) return;
    setTimeout(() => {
      modal.style.display = "none";
      modal.style.height = "0";
      document.getElementById("whatflow-button-container").classList.remove("hidden");
      document.body.classList.remove("overflow_hidden");
      document.body.classList.remove("overflow_mobile");
      announcement_bar?.classList.remove("hidden--mobile");
      headerElement?.classList.remove("view_increase");
      if (header_component) {
        header_component.setAttribute("transparent", "not-sticky");
      }
    }, 200);
  });

  //  RESIZE & SCROLL FIX — coalesce into a single adjust per frame. adjustModal
  //  reads offsetHeight (forced layout) and writes styles, so running it on every
  //  raw scroll/resize event thrashes layout; rAF batches it to once per frame.
  let adjustScheduled = false;
  function scheduleAdjust() {
    if (adjustScheduled || !modal || modal.style.display !== "flex") return;
    adjustScheduled = true;
    requestAnimationFrame(() => {
      adjustScheduled = false;
      if (modal.style.display === "flex") window.adjustModal();
    });
  }
  window.addEventListener("scroll", scheduleAdjust, { passive: true });
  window.addEventListener("resize", scheduleAdjust);
});

// additional options (delegated — .card-stack is injected lazily)
document.addEventListener('click', function (e) {
  const cardStack = e.target.closest('.card-stack');
  if (!cardStack) return;

  const contrastOptions = document.querySelectorAll('.overview-list.style-list .contrast-options');
  const makeSelections = document.querySelectorAll('.card-stack-text');
  if (contrastOptions.length <= 3 || !makeSelections.length) return;

  // State based on 4th element (first 3 are always visible).
  const isShowing = contrastOptions[3].classList.contains('hidden');

  //   First 3 cards only toggle "show"; the rest also toggle "hidden".
  contrastOptions.forEach((el, index) => {
    el.classList.toggle('show', isShowing);
    if (index >= 3) el.classList.toggle('hidden', !isShowing);
  });

  cardStack.classList.toggle('active', isShowing);
  makeSelections[0].textContent = isShowing ? 'HIDE' : 'SHOW MORE';

  const SHOW_BG = '#4eb74e';
  const HIDE_BG = 'linear-gradient(0deg,rgba(112, 112, 112, 1) 0%, rgba(20, 21, 22, 1) 40%)';
  makeSelections.forEach(el => {
    el.style.background = isShowing ? SHOW_BG : HIDE_BG;
  });

  //   Mobile-only width/scroll tweaks — only query these nodes when on mobile.
  const optionCard = window.innerWidth < 450 ? cardStack.querySelector('.option-card') : null;
  if (!optionCard) return;

  const second = cardStack.querySelector('.second');
  const thrid = cardStack.querySelector('.thrid');
  if (second) second.style.display = isShowing ? 'none' : 'block';
  if (thrid) thrid.style.display = isShowing ? 'none' : 'block';

  if (isShowing) {
    const scrollParent = cardStack.closest('.overview-list');
    // scroll to bottom after a small delay (optional)
    if (scrollParent) {
      setTimeout(() => {
        scrollParent.scrollTo({ top: scrollParent.scrollHeight, behavior: 'smooth' });
      }, 500);
    }
  }

  optionCard.style.width = isShowing ? '100%' : '80%';
  optionCard.style.transition = 'width 0.3s ease';
});
